@let tableRows = rows();
<section class="rm-doc__sec">
  <h3 class="rm-doc__sec-title">{{ 'testResults.report.art.TRACEABILITY.desc' | translate }}</h3>
  <table class="rm-trace">
    <colgroup>
      <col class="rm-trace__col-req" />
      <col class="rm-trace__col-tc" />
      <col class="rm-trace__col-result" />
      <col class="rm-trace__col-short" />
      <col class="rm-trace__col-short" />
    </colgroup>
    <thead>
      <tr>
        <th scope="col">{{ 'testResults.report.trace.requirement' | translate }}</th>
        <th scope="col">{{ 'testResults.report.trace.testCase' | translate }}</th>
        <th scope="col">{{ 'testResults.report.trace.result' | translate }}</th>
        <th scope="col">{{ 'testResults.report.trace.run' | translate }}</th>
        <th scope="col">{{ 'testResults.report.trace.bug' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (r of tableRows; track $index) {
        <tr [class.rm-trace__row--missing]="!r.testCaseId">
          <td>
            <code class="rm-trace__req-id">{{ r.requirementKey }}</code>
            <span class="rm-trace__req-title">{{ r.requirementTitel }}</span>
          </td>
          <td>
            @if (r.testCaseId) {
              <code class="rm-trace__tc-id">{{ r.testCaseKey }}</code>
              <span class="rm-trace__tc-title">{{ r.testCaseTitel }}</span>
            } @else {
              <span class="rm-trace__missing">
                <span aria-hidden="true">⚠</span>
                {{ 'testResults.report.trace.noTestCase' | translate }}
              </span>
            }
          </td>
          <td class="rm-trace__result">
            @if (resultOf(r); as result) {
              <app-res-pill size="sm" [status]="result.pill" [label]="result.labelKey | translate" />
            } @else {
              <span class="rm-dash">—</span>
            }
          </td>
          <td class="rm-trace__lauf">{{ r.laufKey || '—' }}</td>
          <td class="rm-trace__bug" [class.rm-dash]="!r.bugKey">{{ r.bugKey || '—' }}</td>
        </tr>
      }
    </tbody>
  </table>
</section>
